/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";
import "@/bootstrap";

Vue.config.productionTip = false;
window.Vue = Vue; // optional if needed globally

import VueHtmlToPaper from "vue-html-to-paper";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "/assets/css/print.css",
    // '/assets/css/print-orientation.css',
  ],
};
Vue.use(VueHtmlToPaper, options);
Vue.use(ElementUI);

// Global Shimmer/Skeleton Loading Components
import ShimmerLoader from "@components/global/ShimmerLoader.vue";
import CardSkeleton from "@components/global/CardSkeleton.vue";
import TableSkeleton from "@components/global/TableSkeleton.vue";

Vue.component("shimmer-loader", ShimmerLoader);
Vue.component("card-skeleton", CardSkeleton);
Vue.component("table-skeleton", TableSkeleton);

// Global Spinner
import CreativeSpinner from "@components/common/CreativeSpinner.vue";
Vue.component("loading-spinner", CreativeSpinner);




Vue.directive("bootstrap-dropdown", {
  inserted(el) {
    $(el).dropdown({ boundary: "window" });
    applyDirClass(el);
  },
  componentUpdated(el) {
    if (!$(el).data("bs.dropdown")) {
      $(el).dropdown({ boundary: "window" });
    }
    applyDirClass(el);
  },
});

function applyDirClass(el) {
  const menu = el.parentElement.querySelector(".dropdown-menu");
  if (!menu) return;

  menu.classList.toggle(
    "dropdown-menu-right",
    document.documentElement.dir === "ltr"
  );
}

Vue.mixin({
  methods: {
    logError(msg) {
      let format =
        "font-size:17px;color: #cc0000;background: #ffe6e6;padding: 5px;";
      if (typeof msg === "object") {
        // msg = JSON.stringify(msg, null, 4);

        return;
      }
    },
    logInfo(msg) {
      let format =
        "font-size:17px;color: #0084ff;background: #e6f3ff;padding: 5px;";
      if (typeof msg === "object") {
        // msg = JSON.stringify(msg, null, 4);
        return;
      }
    },
    logSuccess(msg) {
      let format =
        "font-size:17px;color: #009900;background: #e6ffe6;padding: 5px;";
      if (typeof msg === "object") {
        // msg = JSON.stringify(msg, null, 4);
        return;
      }
    },
  },
});

/**
 * Now we will load the main plugin (Main Service Provider)
 * that provide us with all required services
 */
import AppServiceProvider from "@providers/AppServiceProvider";
Vue.use(AppServiceProvider);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import router from "@/router";
import store from "@/store";
import App from "@/App.vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

const app = new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});
